const component = {
  template: `
  <div class="compHeaderCenter__comp" ng-style="$ctrl.looks" ng-bind-html="$ctrl.headerTxt"></div>
  `,
  bindings: {
    id: '@',
    headerTxt: '@',
    looks: '<',
  },
  controller() {
    this.$onInit = () => {
    }
  }
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/arribas/compHeaderCenter.js